import { useState } from "react";

const EstadoSelector = ({ value, estados, onChange, parentId = null, width = "100px", disabled = false }) => {
  const [valorTemporal, setValorTemporal] = useState(value);
  
  const handleChange = async (e) => {
    const nuevoValor = Number(e.target.value);
    const valorAnterior = value;
    
    // Cambiar temporalmente el valor visual
    setValorTemporal(nuevoValor);
    
    // Llamar al onChange y esperar el resultado
    const resultado = await onChange(e);
    
    // Si el resultado es null (cancelado), revertir al valor anterior
    if (resultado === null) {
      setValorTemporal(valorAnterior);
    }
  };
  
  // Sincronizar valorTemporal con value cuando cambia externamente
  if (valorTemporal !== value) {
    setValorTemporal(value);
  }
  
  const estadoActual = estados.find(e => e.IdEstado === valorTemporal);
  const esSISA = estadoActual?.Nombre?.toUpperCase().trim() === "SISA";
  const isDisabled = disabled || esSISA;
  
  return (
    <select
      value={valorTemporal ?? ""}
      onChange={handleChange}
      disabled={isDisabled}
      style={{
        backgroundColor: estadoActual?.ColorAsociado || "#ccc",
        border: "none",
        padding: "0.25rem 0.5rem",
        borderRadius: "0.25rem",
        fontWeight: "bold",
        minWidth: width,
        width: width,
        textAlign: "center",
        cursor: isDisabled ? "not-allowed" : "pointer",
        opacity: isDisabled ? 0.7 : 1,
      }}
    >
      {estados.map((e) => (
        <option
          key={e.IdEstado}
          value={e.IdEstado}
          style={{ backgroundColor: e.ColorAsociado, color: "#000" }}
        >
          {e.Nombre}
        </option>
      ))}
    </select>
  );
};

export default EstadoSelector;